import { render, staticRenderFns } from "./DrawingSummaryOpinionView.vue?vue&type=template&id=cf10481e&scoped=true"
import script from "./DrawingSummaryOpinionView.vue?vue&type=script&lang=js"
export * from "./DrawingSummaryOpinionView.vue?vue&type=script&lang=js"
import style0 from "./DrawingSummaryOpinionView.vue?vue&type=style&index=0&id=cf10481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf10481e",
  null
  
)

export default component.exports